<template>
  <v-container fluid class="pa-6 pa-md-8">
    <div class="page-head">
      <h1 class="page-head__title">Deleted Staff</h1>
      <p class="page-head__sub">Restore staff members that were removed.</p>
    </div>

    <div class="toolbar d-flex align-center mb-4">
      <v-text-field
        outlined
        dense
        rounded
        hide-details
        prepend-inner-icon="mdi-magnify"
        placeholder="Search staff…"
        v-model="search"
        color="primary"
        class="toolbar__search"
      />
    </div>

    <v-data-table
      :headers="headers"
      :items="staffList"
      :loading="pageLoading"
      :server-items-length="paginate.total"
      :options.sync="options"
      class="data-table"
      loading-text="Loading… Please wait"
      :search="search"
      :footer-props="{ itemsPerPageOptions: [10, 15, 20] }"
    >
      <template #item.avatar="{ item }">
        <v-avatar size="36" class="cell-avatar">
          <span>{{ item.name | firstLetterFunction }}</span>
        </v-avatar>
      </template>
      <template #item.name="{ item }">
        <span class="cell-strong text-capitalize">{{ item.name }}</span>
      </template>
      <template #item.accountNumber="{ item }">
        <span class="tabular">{{ item.accountNumber }}</span>
      </template>
      <template #item.deletedAt="{ item }">
        <span class="text-muted">{{ item.deletedAt | timestamp }}</span>
      </template>
      <template #item.actions="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              :loading="isLoading"
              @click="$store.dispatch('staffs/restore', item._id)"
              icon
              small
              class="cell-action"
            >
              <v-icon small>mdi-backup-restore</v-icon>
            </v-btn>
          </template>
          <span>Restore deleted staff member</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <SnackBar
      :showSnackBar="showSnackBar"
      :message="message"
      :status="status"
    />
  </v-container>
</template>

<script>
import moment from "moment";
import { loadComponent } from "@/utils/helpers";
import { mapGetters } from "vuex";
import SnackBarMixins from "../../../../mixins/SnackBarMIxins";
export default {
  name: "AllStaffs",
  data() {
    return {
      options: {},
      search: ""
    };
  },
  components: {
    SnackBar: loadComponent(`component/SnackBar`)
  },

  computed: {
    ...mapGetters({
      allStaff: "staffs/getAllStaffs",
      pageLoading: "getIsPageLoading",
      isLoading: "getIsLoading",
      paginate: "staffs/getPagination"
    }),
    form() {
      return {
        name: this.name,
        phone: this.phone,
        accountNumber: this.accountNumber
      };
    },
    staffList() {
      return this.allStaff.filter(searchTerm => {
        return (
          searchTerm.name.toLowerCase().indexOf(this.search.toLowerCase()) !==
          -1
        );
      });
    },

    headers() {
      return [
        {
          text: "",
          value: "avatar",
          filterable: false,
          sortable: false
        },
        {
          text: "Staff Name",
          value: "name",
          filterable: true,
          sortable: false
        },
        {
          text: "Account Number",
          value: "accountNumber",
          filterable: false,
          sortable: false
        },
        { text: "Phone", value: "phone", filterable: false, sortable: false },
        {
          text: "Deleted At",
          value: "deletedAt",
          filterable: false,
          sortable: false
        },
        {
          text: "Actions",
          value: "actions"
        }
      ];
    }
  },
  filters: {
    status(value) {
      return !value ? "Active" : "Inactive";
    },
    timestamp(value) {
      return moment(value).format("YYYY-MM-DD HH:mm");
    },
    firstLetterFunction(value) {
      return value.charAt(0).toUpperCase();
    }
  },
  mixins: [SnackBarMixins],
  watch: {
    options: {
      handler(value) {
        const { itemsPerPage, page } = value;
        const query = `?page=${page}&size=${itemsPerPage}`;
        this.$store.dispatch("staffs/listWithTrash", query);
      },
      deep: true
    }
  },

  methods: {},
  created() {
    const query = `?page=1&size=10`;
    this.$store.dispatch("staffs/listWithTrash", query);
  }
};
</script>

<style scoped>
.toolbar__search {
  max-width: 440px;
  width: 100%;
}
.cell-avatar {
  background: var(--signal-soft);
  color: var(--signal);
  font-size: 13px;
  font-weight: 600;
}
.cell-strong {
  font-weight: 600;
  color: var(--foreground);
}
.text-muted {
  color: var(--muted-foreground);
}
.cell-action {
  color: var(--muted-foreground) !important;
}
.cell-action:hover {
  color: var(--status-delivered) !important;
}
</style>
